module.exports = __webpack_public_path__ + "static/media/021-Fenster-Desinfektion_ID_2.12e78886.mp3";